import { gql } from "@apollo/client";

export const GetPendingApprovals = gql`
	query GetPendingApprovals {
		getPendingAprovals {
			_id
			machineId
			obs
			photosTaken
			pendingChanges {
				machineId
				obs
				photosTaken
			}
			createdAt
			machineInfo {
				name
			}
		}
	}
`;